/**
 * Índices de reajuste contratual.
 * No futuro, as taxas serão sincronizadas com a API do Banco Central (SGS).
 */
export const indices = [
  {
    id: 'idx_igpm',
    organizationId: 'org_3la_labs',
    code: 'IGP-M',
    name: 'Índice Geral de Preços do Mercado',
    source: 'FGV / Banco Central',
    bacenCode: '189',
    status: 'Ativo',
    latestRate: 4.52,
    latestPeriod: '12/2025',
    unit: '% a.a.',
    description: 'Índice amplamente usado em contratos de serviços e aluguel.',
    rates: [
      { period: '01/2025', rate: 0.45 },
      { period: '02/2025', rate: 0.38 },
      { period: '03/2025', rate: 0.52 },
      { period: '04/2025', rate: 0.41 },
      { period: '05/2025', rate: 0.29 },
      { period: '06/2025', rate: 0.33 },
      { period: '07/2025', rate: 0.27 },
      { period: '08/2025', rate: 0.31 },
      { period: '09/2025', rate: 0.36 },
      { period: '10/2025', rate: 0.28 },
      { period: '11/2025', rate: 0.34 },
      { period: '12/2025', rate: 0.58 },
    ],
  },
  {
    id: 'idx_ipca',
    organizationId: 'org_3la_labs',
    code: 'IPCA',
    name: 'Índice Nacional de Preços ao Consumidor Amplo',
    source: 'IBGE / Banco Central',
    bacenCode: '433',
    status: 'Ativo',
    latestRate: 4.18,
    latestPeriod: '12/2025',
    unit: '% a.a.',
    description: 'Índice oficial de inflação do Brasil, usado em contratos públicos e privados.',
    rates: [
      { period: '01/2025', rate: 0.42 },
      { period: '02/2025', rate: 0.31 },
      { period: '03/2025', rate: 0.48 },
      { period: '04/2025', rate: 0.35 },
      { period: '05/2025', rate: 0.26 },
      { period: '06/2025', rate: 0.22 },
      { period: '07/2025', rate: 0.19 },
      { period: '08/2025', rate: 0.24 },
      { period: '09/2025', rate: 0.29 },
      { period: '10/2025', rate: 0.33 },
      { period: '11/2025', rate: 0.41 },
      { period: '12/2025', rate: 0.68 },
    ],
  },
  {
    id: 'idx_inpc',
    organizationId: 'org_3la_labs',
    code: 'INPC',
    name: 'Índice Nacional de Preços ao Consumidor',
    source: 'IBGE / Banco Central',
    bacenCode: '188',
    status: 'Ativo',
    latestRate: 3.91,
    latestPeriod: '12/2025',
    unit: '% a.a.',
    description: 'Mede a variação de preços para famílias de renda baixa e média.',
    rates: [
      { period: '01/2025', rate: 0.39 },
      { period: '02/2025', rate: 0.28 },
      { period: '03/2025', rate: 0.44 },
      { period: '04/2025', rate: 0.32 },
      { period: '05/2025', rate: 0.21 },
      { period: '06/2025', rate: 0.18 },
      { period: '07/2025', rate: 0.17 },
      { period: '08/2025', rate: 0.22 },
      { period: '09/2025', rate: 0.27 },
      { period: '10/2025', rate: 0.3 },
      { period: '11/2025', rate: 0.38 },
      { period: '12/2025', rate: 0.75 },
    ],
  },
  {
    id: 'idx_igpdi',
    organizationId: 'org_3la_labs',
    code: 'IGP-DI',
    name: 'Índice Geral de Preços — Disponibilidade Interna',
    source: 'FGV / Banco Central',
    bacenCode: '190',
    status: 'Ativo',
    latestRate: 4.05,
    latestPeriod: '12/2025',
    unit: '% a.a.',
    description: 'Variante do IGP com base na disponibilidade interna de bens.',
    rates: [
      { period: '01/2025', rate: 0.4 },
      { period: '02/2025', rate: 0.35 },
      { period: '03/2025', rate: 0.47 },
      { period: '04/2025', rate: 0.36 },
      { period: '05/2025', rate: 0.25 },
      { period: '06/2025', rate: 0.28 },
      { period: '07/2025', rate: 0.24 },
      { period: '08/2025', rate: 0.29 },
      { period: '09/2025', rate: 0.32 },
      { period: '10/2025', rate: 0.26 },
      { period: '11/2025', rate: 0.31 },
      { period: '12/2025', rate: 0.52 },
    ],
  },
  {
    id: 'idx_sm',
    organizationId: 'org_3la_labs',
    code: 'SM',
    name: 'Salário mínimo',
    source: 'Governo Federal / Banco Central',
    bacenCode: '1619',
    status: 'Ativo',
    latestRate: 6.79,
    latestPeriod: '01/2026',
    unit: '% a.a.',
    description:
      'Reajuste de 12 meses do salário mínimo nominal. A série SGS 1619 publica o valor em reais.',
    rates: [
      { period: '02/2025', rate: 0 },
      { period: '03/2025', rate: 0 },
      { period: '04/2025', rate: 0 },
      { period: '05/2025', rate: 0 },
      { period: '06/2025', rate: 0 },
      { period: '07/2025', rate: 0 },
      { period: '08/2025', rate: 0 },
      { period: '09/2025', rate: 0 },
      { period: '10/2025', rate: 0 },
      { period: '11/2025', rate: 0 },
      { period: '12/2025', rate: 0 },
      { period: '01/2026', rate: 6.79 },
    ],
  },
  {
    id: 'idx_fixo',
    organizationId: 'org_3la_labs',
    code: 'FIXO',
    name: 'Percentual fixo (sem índice oficial)',
    source: 'Manual',
    bacenCode: null,
    status: 'Ativo',
    latestRate: 5,
    latestPeriod: '—',
    unit: '% a.a.',
    description: 'Reajuste com percentual acordado em contrato, sem vínculo a índice oficial.',
    rates: [],
  },
];
